import { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getCookie } from "util/cookie";
import { segmentTrack } from "util/segment";
import { MARKETING_SESSION_ID_COOKIE_KEY } from "util/marketing_session";
import { SETTINGS_PATH } from "util/routes";

declare global {
  interface Window {
    analytics?: {
      page: (options?: { [key: string]: unknown }) => void;
    };
  }
}

// Restrict the pages we track on, so as to not overwhelm our Segment data cap
const TRACKED_PATHS = Object.freeze(
  new Set([
    "/signup/starter",
    "/signup/pro",
    "/signup/premium",
    "/signup/upload",
    "/upload",
    "/onboarding",
    SETTINGS_PATH,
  ]),
);

function LocationAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (TRACKED_PATHS.has(pathname)) {
      segmentTrack("Loaded An App Page");
    }
    if (!window.analytics) {
      return;
    }
    window.analytics.page({ marketingSessionID: getCookie(MARKETING_SESSION_ID_COOKIE_KEY) });
  }, [pathname]);
  return null;
}

export default memo(LocationAnalytics);
